import React, {useState, useEffect, useRef, useContext} from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {CognitoContext} from '../../contexts/CognitoContext';
import { Doughnut, Line } from 'react-chartjs-2';

import {CHETWODEBLUE, SILVERTREE, LILAC, MUSTARD, BITTERSWEET, SPANISHGREY, OzLoading, OzButton, OzTooltip, OzTable, OzContainer, OzRow, OzCol, OzCard, OzProjectTag} from "@ozwol/webui";

import AccountService from '../../services/AccountService';
import ProjectsService from '../../services/ProjectsService';
import UsagesService from './../../services/UsagesService';

import Meta from '../../components/Meta';
import ReferencePeriodTimeline from '../../common/ReferencePeriodTimeline';
import PeriodTotal from '../../chunks/PeriodTotal';
import PageHeader from '../../components/PageHeader';
import HealthyWrapper from '../../components/HealthyWrapper';
import CardHeaderTitle from '../../components/CardHeaderTitle';
import MegaTooltip from '../../components/MegaTooltip';
import ChartWrapper from '../../components/ChartWrapper';

import {getChartOptions, changeDate, checkPermission, getArrayFromInterval, formatError, convertNumber, convertSize, getFormattedDate, getFormattedTime, getWeekDay, isSameDate} from '../../helpers';

const USAGES_INDEX_COLUMN = 1;
// const USAGES_ASSETS_COLUMN = 2;
const USAGES_CREDITS_COLUMN = 3;
const USAGES_STORAGE_COLUMN = 4;
const USAGES_TRANSFER_COLUMN = 5;
const USAGES_PROJECT_COLUMN = 0;

const CardPhraseCollapsed = styled.div`
  min-width: 160px;
  text-align: right;
  display: flex;
  justify-content: end;
  height: 100%;
`;

const CardPhrase = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const CardPhraseText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #303030;
  position: relative;
  top: 2px;

  display: flex;
  // align-items: baseline;
`;
const CardPhraseSuperNumber = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #303030;
  margin: 0px 5px;
  position: relative;
  top: -2px;
`;

const MegaBadgeCnt = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

const MegaBadge = styled.div`
  background: #ffffff;
  border: 2px solid ${props => props.variant === "today" ? SILVERTREE+"60" : LILAC};
  color: #303030;
  text-align: center;
  display: inline-block;
  width: 100%;
  padding: 15px 40px;
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
`;

const RechargeIcon = styled.div`
  color: ${CHETWODEBLUE};
  margin-top: 2px;
  margin-bottom: -2px;
  & > span{
    font-size: 20px;
  }
`;

const PlanDot = styled.div`
  display: inline-block;
  background-color: ${SILVERTREE};
  width: 11px;
  height: 11px;
  border-radius: 3px;
`;
const RechargeDot = styled.div`
  display: inline-block;
  background-color: ${MUSTARD};
  width: 11px;
  height: 11px;
  border-radius: 3px;
`;


const BarWrapper = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  
  background-color: #EBEBEB;
`;
const BarFiller = styled.div`
  width: ${props => props.width}%;
  border: 1px solid ${props => props.color};
  background-color: ${props => props.color}33;
  &:not(:last-child){
    // border-right: 1px solid #fff;
  }

  &:hover{
    background-color: ${props => props.color}99;
  }
`;
const NoLog = styled.div`
  text-align: center;
  padding: 50px;
  font-size: 12px;
  font-weight: 400;
`;
const NoLogSmall = styled.div`
  text-align: center;
  padding: 0px;
  font-size: 12px;
  font-weight: 400;
`;


const Detail = styled.div`
  text-transform: uppercase;
  color: ${CHETWODEBLUE};
  
  font-size: 12px;
`;
const ScrollRef = styled.div`
  scroll-margin: 70px;
`;



const DashGrid = styled.div`
  height: 100%;
  display: grid;
	gap: 20px;
	grid-template-columns: 2fr 1fr;
	grid-template-rows: repeat(2, 1fr);
`;
const DashGridL = styled.div`
	grid-area: 1 / 1 / 3 / 2;
`;
const DashGridR1 = styled.div`
	grid-area: 1 / 2 / 2 / 3;
`;
const DashGridR2 = styled.div`
	grid-area: 2 / 2 / 3 / 3;
`;


const CreditsDashboard = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;
const CreditsDashboardLeft = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  width: calc(100% - 250px);
  & > * {
    width: 100%;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;    
  }
`;
const CreditsDashboardRight = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  width: 250px;
  & > * {
    width: 100%;
    padding: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;   
    border-left: 0px;
  }
`;
const CreditsGrid = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(${props => props.slot},1fr);
`;
const CreditsGridBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 30px 0px;
  text-align: right;
  &:not(:first-child){
    border-top: 1px solid #d5d9ed;
  }

  background: ${props => props.important ? LILAC : "#ffffff"};
  color: ${props => props.important ? CHETWODEBLUE : "#303030"};
`;
const CreditsGridLabel = styled.div`
  // border: 1px solid lime;
  font-size: 11px;
`;
const CreditsGridValue = styled.div`
  display: inline-block;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  margin-top: 1px;
`;
const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: ${props => props.color};
  margin: 0 auto;
`;

const MiniChartWrapper = styled.div`
  height: 50px;
  margin-top: 10px;
`;

const Overview = ({refScrollerPage}) => {
  const [user, setUser] = useState(null);
  const [period, setPeriod] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(-1);
  const [periodHistory, setPeriodHistory] = useState(null);
  const [usage, setUsage] = useState(null);
	const [customizations, setCustomizations] = useState(null);
  const {cognito} = useContext(CognitoContext);

  const [projects, setProjects] = useState([]);
  const [fetchError, setFetchError] = useState(false);
  
  const scrollToProjects = useRef();
  const [collapsedProjects, setCollapsedProjects] = useState(false);
  
  const scrollToCredits = useRef();
  const [collapsedCredits, setCollapsedCredits] = useState(false);
  const [loading, setLoading] = useState(true);

  
  const [arrayOfDays, setArrayOfDays] = useState([]);

  const [usagesCreditsConsumed, setUsagesCreditsConsumed] = useState(null);
  const [usagesStorageInUse, setUsagesStorageInUse] = useState(null);
  const [usagesTransferConsumed, setUsagesTransferConsumed] = useState(null);
  // const [usagesAssetsProcessed, setUsagesAssetsProcessed] = useState(null);
  
  const [usagesLineCredits, setUsagesLineCredits] = useState(null);
  const [usagesDoughnut, setUsagesDoughnut] = useState(null);
  const [usagesCustomBarStorage, setUsagesCustomBarStorage] = useState(null);
  const [usagesCustomBarTransfer, setUsagesCustomBarTransfer] = useState(null);
  
  // const [usagesProjectsTable, setUsagesProjectsTable] = useState(null);

  // const [isDeletingAccount, setDeletingAccount] = useState(false); /* TODO Valorizzare */
  // const [isDeletingAccount] = useState(false); /* TODO Valorizzare */


  useEffect(() => {
    if(checkPermission("period", "read") && checkPermission("period", "list")){
      if(period === null || selectedPeriod !== period.sequenceNumber){
        AccountService.getPeriod({
          "includeRecharges": true
        }, selectedPeriod).then((response1) => {
          setPeriod(response1);
          setSelectedPeriod(response1.sequenceNumber);
          if(response1.currentPlan){  
            setArrayOfDays(getArrayFromInterval(response1.startDate, response1.endDate ? response1.endDate : new Date(), "day"));
          }
          if(response1.currentPlan){   
            if(response1.startDate){
							     

							AccountService.listCustomizationsfees({
								"startDate": response1.startDate,
								"endDate": response1.endDate
							}, selectedPeriod).then((response2) => {
									setCustomizations(response2.result);
							}).catch((error) => {
								setFetchError(formatError(error));
							});
							
              AccountService.listUsages({
                "unit": "HOURS",
                "startDate": response1.startDate,
                "endDate": response1.currentPlan.planType === "PAID" ? response1.endDate : null
              }).then((response2) => {
                if(response2 && response2.result){
                  setUsage(response2.result);
                  setLoading(false);
                }  
              }).catch((error) => {
                setFetchError(formatError(error));
              }); 
            }
          }
          
        }).catch((error) => {
          setFetchError(formatError(error));
        }); 
      }
    }else{
      setLoading(false);
    }
  }, [period, selectedPeriod]);

  useEffect(() => {
    if(user && period && arrayOfDays.length > 0){
      let params = {};
      params.grain = "d";
      params.hideTrivial = false;
      params.start = period.startDate;
      params.end = period.endDate; 
      params.ownerUuid = user.uuid; 
      UsagesService.listByProjects(params).then((usages) => {    
        let creditsConsumed = usages.dataset.reduce((accumulator, currentValue) => {
          return accumulator + currentValue[USAGES_CREDITS_COLUMN]
        },0);

        //TODAY&MAX
        // let index;

        setUsagesCreditsConsumed(
          usages.dataset.reduce((accumulator, currentValue) => {
            return accumulator + currentValue[USAGES_CREDITS_COLUMN]
          },0)
        );
        // setUsagesAssetsProcessed(
        //   usages.dataset.reduce((accumulator, currentValue) => {
        //     return accumulator + currentValue[USAGES_ASSETS_COLUMN]
        //   },0)
        // );     
        setUsagesStorageInUse(usages.dataset.filter(set => isSameDate(set[USAGES_INDEX_COLUMN], changeDate(new Date(),-1,"days"), "d")).reduce((accumulator, currentValue) => {
          return accumulator + currentValue[USAGES_STORAGE_COLUMN]
        },0));           
        setUsagesTransferConsumed(
          usages.dataset.reduce((accumulator, currentValue) => {
            return accumulator + currentValue[USAGES_TRANSFER_COLUMN]
          },0)
        );

        setUsagesDoughnut({
          datasets: [{
            labels: [...projects.map(project => project.name), "Available credits"],
            data: [
              ...projects.map(project => 
                usages.dataset.filter(set => set[USAGES_PROJECT_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
                  return accumulator + currentValue[USAGES_CREDITS_COLUMN]
                },0)
              ),
              period.creditsRecharged - creditsConsumed
            ],
            borderWidth: 1,
            backgroundColor: [...projects.map(project => project.color), "#ebebeb"]
          }]
        });
        
        setUsagesCustomBarStorage(
          projects.map(project => ({
            name: project.name,
            color: project.color,
            value: usages.dataset.filter(set => set[USAGES_PROJECT_COLUMN] === project.uuid && isSameDate(set[USAGES_INDEX_COLUMN], changeDate(new Date(),-1,"days"), "d")).reduce((accumulator, currentValue) => {
              return accumulator + currentValue[USAGES_STORAGE_COLUMN]
            },0)
          }))  
        );
        
        setUsagesCustomBarTransfer(
          projects.map(project => ({
            name: project.name,
            color: project.color,
            value: usages.dataset.filter(set => set[USAGES_PROJECT_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
              return accumulator + currentValue[USAGES_TRANSFER_COLUMN]
            },0)
          }))  
        );

				// setUsagesProjectsTable(
				// 	projects.map(project => ({
				// 		"name": project.name,
				// 		"color": project.color,
				// 		"assetsProcessedToday": 0,
				// 		"assetsProcessed": 0,
				// 		"scriptCredits": 0,
				// 		"storage": usages.dataset.filter(set => set[USAGES_PROJECT_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
				// 			return accumulator + currentValue[USAGES_STORAGE_COLUMN]
				// 		},0),
				// 		"storageCredits": 0,
				// 		"transfer": usages.dataset.filter(set => set[USAGES_PROJECT_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
				// 			return accumulator + currentValue[USAGES_TRANSFER_COLUMN]
				// 		},0),
				// 		"trasferCredits": usages.dataset.filter(set => set[USAGES_PROJECT_COLUMN] === project.uuid).reduce((accumulator, currentValue) => {
				// 			return accumulator + currentValue[USAGES_CREDITS_COLUMN]
				// 		},0),
				// 	}))
				// );
				// console.log(usagesProjectsTable);

				setUsagesLineCredits({
					labels: arrayOfDays,
					datasets: [{
						data: arrayOfDays.map((day) => 
										new Date(day) <= new Date() ? 
											usages.dataset.filter(set => set[USAGES_INDEX_COLUMN] <= day).reduce((accumulator, currentValue) => {
												return accumulator + currentValue[USAGES_CREDITS_COLUMN]
											},0)
										:
											null
									),
						borderColor: CHETWODEBLUE,
						tension: 0.1
					},{
						data: arrayOfDays.map((day) => period.currentPlan.credits,0),
						borderColor: SILVERTREE,
						tension: 0.1
					},{
						data: arrayOfDays.map((day) => period.creditsRecharged,0),
						borderColor: MUSTARD,
						tension: 0.1
					}]
				});

        
      }).catch((error) => {
        setFetchError(formatError(error));
      });
    }
  }, [user, projects, period, arrayOfDays]);

  useEffect(() => {
    
    if(checkPermission("period", "read") && checkPermission("period", "list")){
      if(!cognito.groups.includes("OzwolCoworker")){
        AccountService.getUser().then((response) => {
          setUser(response);
        }).catch((error) => {
          setFetchError(formatError(error));
        }); 
      }
      if(checkPermission("period", "list")){
        AccountService.listPeriods().then((response) => {
          if(response && response.result){
            setPeriodHistory(response.result.slice(0, 6).reverse());
          }
        }).catch((error) => {
          setPeriodHistory(null);
          setFetchError(formatError(error));
        });
      }
    }
    if(checkPermission("project", "list")){
      ProjectsService.list().then((response3) => {
        let projects = response3;
        setProjects(projects);    
      }).catch((error) => {
        setFetchError(formatError(error));
      }); 
    }
  }, [cognito]);

  return (
    <OzContainer size="extra">
      <Meta title={"Overview"} />
      <PageHeader
        breadcrumbsIcon="mountain_flag"
        breadcrumbsText={["Overview", "Overall"]}
        refScrollerPage={refScrollerPage}
        anchors={[
          checkPermission("project", "list") ? {
            "icon": "business_center",
            "text": "Projects",
            "ref": scrollToProjects,
            "callback": () => {setCollapsedProjects(null); setTimeout( ()=> { setCollapsedProjects(false);},1)}
          } : null,
          checkPermission("period", "read") && checkPermission("period", "list") ? {
            "icon": "toll",
            "text": "Credits",
            "ref": scrollToCredits,
            "callback": () => {setCollapsedCredits(null); setTimeout( ()=> { setCollapsedCredits(false);},1)}
          } : null
        ]}
        rightContent={user ? <>
           {
            user.status === "OPERATIVE" && user.accountToBeClosed === false ? "Active account" : 
            user.status === "OPERATIVE" && user.accountToBeClosed === true ? "Account to be closed" : 
            user.status === "SUSPENDED" ? "Suspended account" : 
            user.status === "CLOSED" ? "Closed account" : 
            null
          }
          &nbsp;
          <Dot color={
            user.status === "OPERATIVE" && user.accountToBeClosed === false ? SILVERTREE : 
            user.status === "OPERATIVE" && user.accountToBeClosed === true ? MUSTARD : 
            user.status === "SUSPENDED" ? BITTERSWEET : 
            user.status === "CLOSED" ? SPANISHGREY : 
            null
          } />
        </> : null}
      />
      <HealthyWrapper error={fetchError} loading={loading}>
        {checkPermission("period", "read") && checkPermission("period", "list") ? 
          <>
            <OzRow>
              {period && periodHistory && periodHistory.length > 1 ? periodHistory.map((val, i) => 
                <OzCol widthmd={2} key={i}>
                  <OzButton
                    width="100%"
                    variant={selectedPeriod === val.sequenceNumber ? "silvertree-o" : "push-black"}
                    onClick={() => setSelectedPeriod(val.sequenceNumber)}
                  >
                    {new Date(val.endDate) > new Date() ?
                      "Current"
                    :
                      getFormattedDate(val.startDate, false) + " - " + getFormattedDate(val.endDate, false)
                    }
                  </OzButton>
                </OzCol>
              ) : null }
            </OzRow>
            <br/>
            <OzRow>
              {period ?
                <OzCol>
                  <OzCard
                    headerLeft={
                      <CardHeaderTitle title="Reference period" />
                    }
                  >
                    <ReferencePeriodTimeline
                      period={period}
                      user={user}
                    />
                  </OzCard>
                </OzCol>
              : <OzLoading /> }

              {usagesDoughnut && period && projects ?
                <>
									<OzCol widthmd="12">    
										<DashGrid>
											<DashGridL>
												<CreditsDashboard>
													<CreditsDashboardLeft>
														<OzCard
															height="100%"
															headerLeft={
																<>
																	<CardHeaderTitle title={"Credits usage " + (usagesCreditsConsumed ? 
																		convertNumber(Math.round(
																			(usagesCreditsConsumed * 100 / period.creditsRecharged) * 10
																		) /10)
																	: 0) + "%"}  />
																</>
															}
														>                
															<center>
																<div style={{"maxWidth": "400px"}}>
																	<ChartWrapper width="170px">
																		<Doughnut
																			options={getChartOptions({type: "doughnut"})}
																			data={usagesDoughnut} 
																		/>
																	</ChartWrapper> 
																</div>                           
																
															</center>
														
														</OzCard>
													</CreditsDashboardLeft>
													<CreditsDashboardRight>
														<OzCard
															height="100%"
														> 
															<CreditsGrid slots={period.currentPlan.planType === "PAID" ? 5 : 3}>
																<CreditsGridBox>
																	<CreditsGridLabel>Credits used during this period</CreditsGridLabel>
																	<CreditsGridValue>{usagesCreditsConsumed ? convertNumber(usagesCreditsConsumed) : 0}  <small>of</small> {convertNumber(period.creditsRecharged)}</CreditsGridValue>
																</CreditsGridBox>
																<CreditsGridBox>
																	<CreditsGridLabel>Plan included credits</CreditsGridLabel>
																	<CreditsGridValue>{convertNumber(period.currentPlan.credits)}</CreditsGridValue>
																</CreditsGridBox>
																{period.currentPlan.planType === "PAID" ?
																	<>
																		<CreditsGridBox>
																			<CreditsGridLabel>Roll-over credits</CreditsGridLabel>
																			<CreditsGridValue>{convertNumber(period.creditsRollOver)}</CreditsGridValue>
																		</CreditsGridBox>
																		<CreditsGridBox>
																			<CreditsGridLabel>Recharges ({period.rechargesCount})</CreditsGridLabel>
																			<CreditsGridValue>{convertNumber(period.rechargesCount * period.currentPlan.rechargeCredits)}</CreditsGridValue>
																		</CreditsGridBox>
																	</>
																: null }
																<CreditsGridBox important>
																	<CreditsGridLabel>Total credits</CreditsGridLabel>
																	<CreditsGridValue>{convertNumber(period.creditsRecharged)}</CreditsGridValue>
																</CreditsGridBox>
															</CreditsGrid>
														</OzCard>
													</CreditsDashboardRight>
												</CreditsDashboard> 
											</DashGridL>
											<DashGridR1>
												<OzCard
													height="100%"
													headerLeft={
														<CardHeaderTitle 
															title={<><OzTooltip>Average use over the current period</OzTooltip> Storage in use</>}
														/>
													}
												>
													<MegaBadgeCnt>
														{new Date(period.endDate) > new Date() ?
															<>
																<MegaBadge>{usagesStorageInUse ? convertSize(usagesStorageInUse) : 0}</MegaBadge>
																<br/>
																<br/>
																<BarWrapper>
																	{usagesCustomBarStorage ? 
																		usagesCustomBarStorage.filter(item => item.value > 0).map((item, i) =>                                   
																			<BarFiller key={i} color={item.color} width={item.value * 100 / usagesStorageInUse}>
																				<MegaTooltip
																					title="Storage in use"
																					subtitle={item.name}
																					value={convertSize(item.value)}
																				/>
																			</BarFiller>
																		)
																	: null}
																</BarWrapper>
															</>
														: 
															<NoLogSmall>The data is not available for this period.</NoLogSmall>    
														}
													</MegaBadgeCnt>
												</OzCard>
											</DashGridR1>
											<DashGridR2>
												<OzCard
                          height="100%"
                          headerLeft={
                            <>
                              <CardHeaderTitle title={<><OzTooltip>Only transfer in download is charged; transfer in upload is free</OzTooltip> Data transfer consumed</>} />            
                            </>
                          }
                        >
                          <MegaBadgeCnt>
                            <MegaBadge>{usagesTransferConsumed ? convertSize(usagesTransferConsumed) : 0}</MegaBadge>
                            <br/>
                            <br/>
                            <BarWrapper>
                              {usagesCustomBarTransfer ? 
                                usagesCustomBarTransfer.filter(item => item.value > 0).map((item, i) =>                                   
                                  <BarFiller key={i} color={item.color} width={item.value * 100 / usagesTransferConsumed}>
                                    <MegaTooltip
                                      title="Data transfer consumed"
                                      subtitle={item.name}
                                      value={convertSize(item.value)}
                                    />
                                  </BarFiller>
                                )
                              : null}
                            </BarWrapper>
                              </MegaBadgeCnt>
                        </OzCard>
											</DashGridR2>
										</DashGrid>
									</OzCol>
                </>
              : null }

              

              
              
              
            </OzRow>
            <br/>
          </>
        : null}
        <OzRow>          
          {checkPermission("project", "list") ? 
            <>
              { projects ?
                <OzCol>
                <ScrollRef ref={scrollToProjects} />      
                  <OzCard
                    height="100%"
                    collapsible={true}
                    collapsed={collapsedProjects}
                    headerLeft={<CardHeaderTitle title="Projects overview" />}
                    headerRight={
                      <CardPhrase>
                        <CardPhraseText>
                          Number of projects
                          <CardPhraseSuperNumber>
                            {projects.length}
                          </CardPhraseSuperNumber>
                        </CardPhraseText>
                      </CardPhrase>
                    }
                  >
                    <OzTable
                    columns={[
                      "Project",
                      "Assets processed today",
                      "Assets processed",
                      "Script credits",
                      "Storage",
                      "Storage credits",
                      "Data transfer",
                      "Data transfer credits",
                      "Estimated project cost",
                  //    "Operations"
                    ]}
                    values={projects.map((item, i) => (({values: [
                      <Link to={"/project/" + item.uuid + "/dashboard"}>
                        <OzProjectTag
                          name={item.name}
                          color={item.color}
                          uuid={item.uuid}
                          direction={"horizontal"}
                          display={"inline"}
                        />
                      </Link>,
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 && usage.filter(p=> p.projectUuid === item.uuid)[0].days.filter(day => isSameDate(day.date, new Date(), "d")).length > 0 ? convertNumber(usage.filter(p=> p.projectUuid === item.uuid)[0].days.filter(day => isSameDate(day.date, new Date(), "d"))[0].assetsProcessed) : "-",
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 ? convertNumber(usage.filter(p=> p.projectUuid === item.uuid)[0].assetsProcessed) : "-",
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 ? convertNumber(usage.filter(p=> p.projectUuid === item.uuid)[0].scriptCredits) : "-",
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 ? convertSize(usage.filter(p=> p.projectUuid === item.uuid)[0].storageInUse) : "-",
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 ? convertNumber(usage.filter(p=> p.projectUuid === item.uuid)[0].storageCredits) : "-",
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 ? convertSize(usage.filter(p=> p.projectUuid === item.uuid)[0].transferConsumed) : "-",
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 ? convertNumber(usage.filter(p=> p.projectUuid === item.uuid)[0].transferCredits) : "-",
                      usage && usage.filter(p=> p.projectUuid === item.uuid).length > 0 && (
												usage.filter(p=> p.projectUuid === item.uuid)[0].scriptCredits > 0 ||
												usage.filter(p=> p.projectUuid === item.uuid)[0].transferCredits > 0 ||
												usage.filter(p=> p.projectUuid === item.uuid)[0].storageCredits > 0
											) ? "€ "+convertNumber((
												(
													usage.filter(p=> p.projectUuid === item.uuid)[0].scriptCredits +
													usage.filter(p=> p.projectUuid === item.uuid)[0].transferCredits + 
													usage.filter(p=> p.projectUuid === item.uuid)[0].storageCredits
												) * parseFloat((period.currentPlan.price/period.currentPlan.credits).toFixed(4))
											).toFixed(2)) : "-",
                  //    "???"
                    ]})))}/>
                  </OzCard>
                </OzCol>
              : <OzLoading /> }
            </>
          : null }

          {checkPermission("period", "read") && checkPermission("period", "list") ? 
            <>
              {period && period.currentPlan.planType === "PAID" ? 
                <>
                  {period.recharges && period.currentPlan ?
                    <OzCol>          
                      <OzCard
                        height="100%"
                        headerLeft={
                          <CardHeaderTitle 
                            title="Recharges" 
                            subtitle={<>{period.recharges.length} recharge in this period</>}
                          />
                        }
                        headerRight={
                          <CardPhrase>
                            <CardPhraseText>
                              Total sum of recharges
                              <CardPhraseSuperNumber>
                                {period.recharges.length > 0 ? convertNumber(period.recharges.map(item => item.creditsRecharged).reduce((a, b) => a + b, 0),0) : 0}
                              </CardPhraseSuperNumber>
                            </CardPhraseText>
                          </CardPhrase>
                        }
                        footerRight={
                          <Link to={"/overall/recharges"}>
                            <Detail>Detail</Detail>
                          </Link>
                        }
                      >

                        {period && period.recharges && period.recharges.length > 0 ?
                          <OzTable
                            columns={[
                              "",
                              "Date",
                              "Time",
                              <center>Credits</center>,
                              <center>Cost</center>
                            ]}
                            values={period.recharges.slice(-5).map(item => ({values: [
                              <RechargeIcon><span className="material-symbols-outlined">nearby</span></RechargeIcon>,
                              getFormattedDate(item.createDatetime),
                              getFormattedTime(item.createDatetime, false),
                              <center>{convertNumber(item.creditsRecharged)}</center>,
                              <center>{convertNumber(item.price)+"€"}</center>
                            ]}))}
                          />
                        :
                          <NoLog>No automatic charging during this period.</NoLog>
                        }
                      </OzCard>
                    </OzCol>
                  : <OzLoading /> }
                </>
              : null }
            </>
          : null}
          {checkPermission("period", "read") && checkPermission("period", "list") ? 
            <>
              {period && period.currentPlan.planType === "PAID" ? 
                <>
                  {period.currentPlan ?
                    <OzCol>
                      <PeriodTotal
                        numRecharges={period.recharges && period.recharges.length > 0 ? period.recharges.length : 0}
                        totRecharges={period.recharges && period.recharges.length > 0 ? period.recharges.map(item => item.price).reduce((a, b) => a + b, 0) : 0}
												totCustomizations={customizations && customizations.length > 0 ? customizations.map(item => item.quantity * item.price).reduce((a, b) => a + b, 0) : 0}
                        planName={period.currentPlan ? period.currentPlan.name : null}
                        planPrice={period.currentPlan ? period.currentPlan.price : 0}
                        isDeletingAccount={period.currentPlan.planType === "PAID" && (user && !user.nextPlan)}
                      />
                    </OzCol>
                  : <OzLoading /> }
                </>
              : null }
            </>
          : null}
          {checkPermission("period", "read") && checkPermission("period", "list") ? 
            <>
              {period && period.currentPlan ?
                <OzCol>
                  <ScrollRef ref={scrollToCredits} />
                  <OzCard
                    height="100%"
                    collapsible={true}
                    collapsed={collapsedCredits}
                    headerLeft={
                      <CardHeaderTitle 
                        title="Plan credits usage" 
                        subtitle={<>Usage since {getFormattedDate(period.startDate)}</>}
                      />
                    }
                    headerCenterCollapsed={
                      usagesLineCredits ?
												<MiniChartWrapper>
													<Line options={getChartOptions({   
															yScaleLabel: (val) => convertNumber(val),    
															tooltipTitle: (val) => getFormattedDate(val), 
															type: "line", 
															isMini: true
														})} data={usagesLineCredits} />
												</MiniChartWrapper>
											: null
                    }
                    headerRight={
                      <CardPhrase>
                        <CardPhraseText>
                          Total credits usage over the {new Date(period.endDate) > new Date() ? "selected" : "current"} period
                          <CardPhraseSuperNumber>
                            {convertNumber(usagesCreditsConsumed,0)}
                          </CardPhraseSuperNumber>
                        </CardPhraseText>
                      </CardPhrase>
                    }
                    headerRightCollapsed={
                      <CardPhraseCollapsed>
                        <CardPhrase>
                          <CardPhraseText>
                            <CardPhraseSuperNumber>
                            {convertNumber(usagesCreditsConsumed,0)}
                            </CardPhraseSuperNumber>
                          </CardPhraseText>
                        </CardPhrase>
                      </CardPhraseCollapsed>
                    }
                  >
										{usagesLineCredits ? 
											<Line options={getChartOptions({  
												xScaleLabel: (i) => arrayOfDays.length <= 31 ? 
													[(new Date(arrayOfDays[i])).getDate(), getWeekDay(arrayOfDays[i]).substring(0,1)]
													:
													getFormattedDate(new Date(arrayOfDays[i])),         
												yScaleLabel: (val) => convertNumber(val),    
												tooltipTitle: (val) => getFormattedDate(val), 
												type: "line", 
											})} data={usagesLineCredits} />
                    : 
                      <NoLog>No credits usage during this period.</NoLog>    
                    }
                    <br/>
                    <PlanDot />&nbsp; Plan included Credits &nbsp;&nbsp;&nbsp; <RechargeDot />&nbsp; Available Credits
                  </OzCard>
                </OzCol>
              : <OzLoading /> }
            </>
          : null}
        </OzRow>
      </HealthyWrapper>
    </OzContainer>
  )
}

export default Overview;
